import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from '@purespectrum1/ui/dropdown';
import { ButtonModule } from '@purespectrum1/ui/button';
import { ModalModule } from '@purespectrum1/ui/modal';
import { GoogleTagManagerModule } from '@purespectrum1/ui/tracking';
import { MultiCountryDraftComponent } from './multi-country-draft/multi-country-draft.component';
import { SelectDropdownModule } from '@purespectrum1/ui/select-dropdown';
import { ZeroDashPipeModule } from '../../pipes/zero-dash-pipe.module';
import { ChangeSurveyStatusModalComponent } from '../../../../shared/ui/change-survey-status-modal/change-survey-status-modal.component';
import { SortTableModule } from '../../../../shared/ui/sort-table/sort-table.module';
import { InputDecimalRestrictionModule } from '../../../../shared/ui/input-decimal-restriction/input-decimal-restriction.module';
import { InputRestrictionModule } from '../input-restriction/input-restriction.module';
import { LayoutModule } from '../../../../create-surveys/layout/layout.module';

@NgModule({
  declarations: [MultiCountryDraftComponent, ChangeSurveyStatusModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    ButtonModule,
    ModalModule,
    SortTableModule,
    SelectDropdownModule,
    ZeroDashPipeModule,
    InputDecimalRestrictionModule,
    InputRestrictionModule,
    GoogleTagManagerModule,
    LayoutModule,
  ],
  exports: [MultiCountryDraftComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MultiCountryModule {}
